import { DataTableCellProps, TableCell } from 'components/dataTable';

import { FormattedAsId } from './styles';

export const IdCell = ({ className, row, column }: DataTableCellProps & { className?: string }) => {
  const value = row[column.id];
  return (
    <TableCell className={className} data-column={column.id}>
      <FormattedAsId>{value}</FormattedAsId>
    </TableCell>
  );
};
